export default __webpack_public_path__ + "static/4-08969c64208a6102e089d2050bf1212a.webp";